exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FullscreenLoader{position:fixed;top:0;left:0;height:100%;width:100%;background-color:#fff;padding:24px}.FullscreenLoader .text{font-size:24px;color:#7740f9;font-weight:bold;text-align:center;line-height:1.2em}\n", ""]);

// exports
